type ClosePopupBtnProps = {
   close: () => void
}
export default function ClosePopupBtn(props: ClosePopupBtnProps) {
   const { close } = props
   return (
      <div className='closePopupBtn flex center' onClick={() => close()}>
         Fermer
      </div>
   )
}
